import React from "react";
import { Breakdown } from "./Breakdown";
import { Stack } from "@bookingcom/bui-react";
import { Atol, HiddenFees, SIRF, Disclaimers } from "./banners";
import {
  useUnifiedPriceBreakdownPostBookingPaymentController,
  type UnifiedPriceBreakdownPostBookingPaymentControllerProps
} from "./useUnifiedPriceBreakdown.PostBookingPayment.controller";

export type UnifiedPriceBreakdownPostBookingPaymentProps = UnifiedPriceBreakdownPostBookingPaymentControllerProps;

export function UnifiedPriceBreakdownPostBookingPayment(props: UnifiedPriceBreakdownPostBookingPaymentProps) {
  const { unifiedPriceBreakdown, isHungaryDepartingRyanAir, disclaimers, addedItems, expandedByDefault } =
    useUnifiedPriceBreakdownPostBookingPaymentController(props);

  if (!unifiedPriceBreakdown) {
    return null;
  }

  return (
    <Stack>
      <Breakdown
        {...unifiedPriceBreakdown}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        expandedByDefault={expandedByDefault}
        addedItems={addedItems}
      />
      <Disclaimers disclaimers={disclaimers} />
      <Atol />
      <SIRF />
      <HiddenFees />
    </Stack>
  );
}
